export default {
    GetUserInfo: 'api/private/me',
    ChangeUserPassword : "api/private/change_password",
    UpdateUserInfo : "api/private/me",
    UpdateUserProfile : "api/private/me",
    GetNotifications : "api/private/notification",

  };
  